import React, { Component } from 'react';
import { connect } from 'react-redux';
import NotFoundView from './NotFound.view';

export class NotFoundContainer extends Component {
  render() {
    return (
      <NotFoundView {...this.props} />
    );
  }
}

function mapStateToProps() {
  return {
  };
}

// TIP: do not use second parameter ownProps because if you do the it will be called every time component receives props
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotFoundContainer);



// WEBPACK FOOTER //
// ./src/app/modules/NotFound/NotFound.container.js